import { useMemo } from 'react'
import { UserInfo, useUserInfo } from '../../../../ReactRouting/Hooks/useUserInfo'
import { useAppLicenceFeature } from '../useAppLicenceFeature'
import { SELF_PROVISIONING_FEATURE_FLAG } from '../../../../ReactRouting/Constants/FeatureFlags'
import { PermissionsUtil, SELF_PROVISIONING_PERMISSIONS } from '../../Utils/PermissionsUtil'
import { useCheckUserHasPermissions } from '../../../../ReactRouting/Hooks/useCheckPermissions'

export const useUserHasSelfProvisioningPermission = (): Definable<boolean> => {
    const [userInfo]: UserInfo = useUserInfo()
    const isSelfProvisioningEnabled: Definable<boolean> =
        useAppLicenceFeature(SELF_PROVISIONING_FEATURE_FLAG) ?? undefined
    const hasSelfProvisionerPermissions: Definable<boolean> = useCheckUserHasPermissions(SELF_PROVISIONING_PERMISSIONS)
    const isTelSysUser: Definable<boolean> = useMemo(
        (): Definable<boolean> => PermissionsUtil.isTelSysWideUser(userInfo),
        [userInfo]
    )

    return isSelfProvisioningEnabled && hasSelfProvisionerPermissions && isTelSysUser
}
